export default function(_el) {

  const toggle = _el.querySelector('[data-js-expandable-toggle]');
  const content = _el.querySelector('[data-js-expandable-content]');
  
  toggle.addEventListener('click', e => {
    e.preventDefault();
    _el.classList.toggle('expanded');
  });
}